<div [ngStyle]="loaderStyles()" class="inline-flex items-center justify-center gap-(--dot-gap)">
  <span
    class="h-(--dot-size) w-(--dot-size) rounded-full bg-(--dot-color) animate-[botTyping_var(--animation-duration)_infinite_ease-in-out]"
  ></span>
  <span
    class="h-(--dot-size) w-(--dot-size) rounded-full bg-(--dot-color) animate-[botTyping_var(--animation-duration)_150ms_infinite_ease-in-out]"
  ></span>
  <span
    class="h-(--dot-size) w-(--dot-size) rounded-full bg-(--dot-color) animate-[botTyping_var(--animation-duration)_300ms_infinite_ease-in-out]"
  ></span>
</div>
